import { Link } from 'react-router-dom';
import { SiteHeader } from '../components/layout/SiteHeader';
import { EmptyState } from '../components/ui/EmptyState';
import { Button } from '../components/ui/Button';

export default function NotFoundPage() {
  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="centered-page">
        <EmptyState
          title="Pagina niet gevonden"
          body="Deze pagina bestaat niet (meer)."
          action={
            <Button asChild variant="primary">
              <Link to="/">Naar de startpagina</Link>
            </Button>
          }
        />
      </div>
    </div>
  );
}
